import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Context } from 'src/app/shared/models/context';
import { Course, CourseReport, CourseTest, EmployeeReport } from 'src/app/shared/models/course';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CourseService } from 'src/app/shared/services/course.service';
import { CourseReportViewComponent } from './course-report-view/course-report-view/course-report-view.component';

@Component({
  selector: 'app-course-report',
  templateUrl: './course-report.component.html',
  styleUrls: ['./course-report.component.scss']
})

export class CourseReportComponent implements OnInit {

  public isLoading: boolean = true;
  public courseReports: CourseReport[] = [];
  public courses: Course[] = [];
  public courseTests: CourseTest[] = [];
  public courseId: number | null = null;
  public courseTestId: number | null = null;
  public context!: Context;

  constructor(
    private courseService: CourseService,
    private modalService: NgbModal,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.context = this.authService.getContextData();
    this.Courses();
  }

  private Courses() {
    this.courseService.getCourses(false).subscribe((courses: Course[]) => {
      this.courses = courses;
      this.isLoading = false;
      if (this.courses.length > 0) {
        this.courseId = this.courses[0].id;
        this.getCourseTests(this.courseId);
      }
    });
  }

  public onCourseChange(event: any) {
    this.courseId = event.target.value;
    this.courseTestId = null;
    if (this.courseId) {
      this.getCourseTests(this.courseId);
    }
  }

  public getCourseTests(courseId: number) {
    this.isLoading = true;
    this.courseService.getCourseTests(courseId, "RELEASED").subscribe({
      next: (courseTests: CourseTest[]) => {
        this.courseTests = courseTests;
        this.isLoading = false;
        if (this.courseTests.length > 0) {
          this.courseTestId = this.courseTests[0].id;
          this.getCourseReports();
        }
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;
      }
    });
  }
  

  public onCourseTestChange() {
    this.getCourseReports();
  }

  private getCourseReports() {
    if (!this.courseTestId) return;
    this.isLoading = true;
    this.courseService.getCourseReports(this.courseTestId).subscribe({
      next: (courseReports: CourseReport[]) => {
        this.courseReports = courseReports;
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;
      }
    });
  }

  public viewEmployeeReport() {
    this.courseService.getEmployeeTestReport(this.context?.employeeId).subscribe({
      next: (report: EmployeeReport) => {
        const modalRef = this.modalService.open(CourseReportViewComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.employeeReport = report;
      },
      error: (error: HttpErrorResponse) => {
      }
    });
  }

  public getTruncatedName(name: string, maxLength: number): string {
    if (name.length > maxLength) {
      return name.slice(0, maxLength) + '...';
    }
    return name;
  }
}
